<style lang="scss">
@import "resources/sass/v1/abstracts/_variables";

.section-hero {
    position: relative;
    z-index: auto;
    margin-bottom: 16px;

    @media screen and (min-width: $screen-md) {
        margin-bottom: 56px;
    }

    @media screen and (min-width: $screen-xl) {
        margin-bottom: 96px;
    }

    .hero {
        background-color: $primary;
        padding: 40px 0 120px 0;
        position: relative;

        @media screen and (min-width: $screen-lg) {
            padding: 80px 0 120px 0;
        }

        @media screen and (min-width: $screen-xl) {
            padding: 158px 0 158px 0;
        }

        &.large {
            padding: 80px 0 120px 0;

            @media screen and (min-width: $screen-lg) {
                padding: 100px 0 180px 0;
            }

            @media screen and (min-width: $screen-xl) {
                padding: 256px 0 318px 0;
            }
        }

        &:before {
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            content: "";
            background-color: rgba(43, 74, 132, 0.7);
        }

        .content {
            position: relative;
            z-index: 2;
        }
    }

    &:after {
        content: "";
        background-image: url("/svg/shapes/header-1.svg");
        height: 80px;
        width: 100%;
        position: absolute;
        z-index: 2;
        right: 0;
        bottom: 0;

        @media screen and (min-width: $screen-sm) {
            background-size: cover;
            background-repeat: no-repeat;
        }
    }

    .section-bar {
        display: none;
        height: 56px;
        background-color: $white;
        position: fixed;
        top: 80px;
        z-index: 20;

        a {
            font-family: $headings-font-family;
            font-size: $font-weight-in-between;
            font-weight: $font-weight-bold;
        }

        @media screen and (min-width: $screen-md) {
            display: block;
        }
    }
}
</style>

<template>
    <div class="section-hero">
        <div class="hero">
            <div class="container content">
                <div class="row">
                    <div class="col-12 col-xl-10">
                        <div class="intro d-lg-flex">
                            <h1 class="h2 text-white word-break">{{ title }}</h1>
                            <p class="text-white font-weight-light text-cut ml-lg-80 mb-0">{{ description }}</p>
                        </div>
                    </div>
                </div>

                <div v-if="sections" class="sections">
                    <div class="row">
                        <div :v-for="(section, index) in sections" :v-key="index" class="col-12 col-md-6 col-xl-4 mb-45 mb-xl-0">
                            <section-card :section="section" :translations="translations"></section-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="sections" class="section-bar w-100 d-flex justify-content-center">
            <a :v-for="(section, index) in sections" :v-key="index" class="align-self-center text-black mx-16" href="#">GDPR Toolbox</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: false,
        },
        sections: {
            type: Array,
            required: false
        },
        translations: {
            type: Object,
            required: true
        },
    }
}
</script>
